import { AnyAction } from 'redux';
import { App, GisDatenVWG, VwgVorbelegungdaten } from '@ps20-frontend/frontend-models';
import {
  GisDatenErmitteltPayload,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export const gisDatenReducer = function (
  sectionState: GisDatenVWG = null,
  action: AnyAction,
  state: IAppState,
): GisDatenVWG {
  switch (action.type) {
    case VwgActions.PLZ_CHANGED:
    case VwgActions.ORT_CHANGED:
    case VwgActions.STRASSE_CHANGED:
    case VwgActions.HAUSNUMMER_CHANGED:
    case VwgActions.MAP_COORDINATES_VWG_CHANGED_EINGABE:
    case VwgActions.MAP_COORDINATES_VWG_CHANGED_ANGEBOT: {
      return null;
    }
    case GlobalActions.GISDATEN_ERMITTELT: {
      const actionPayload: GisDatenErmitteltPayload = action.payload;
      const gisDaten = actionPayload.gisDaten;
      return {
        ...sectionState,
        ...gisDaten,
        latitude: gisDaten?.latitude ? gisDaten.latitude : sectionState?.latitude,
        longitude: gisDaten?.longitude ? gisDaten.longitude : sectionState?.longitude,
        matchcode: gisDaten?.matchcode ? gisDaten.matchcode : sectionState?.matchcode,
      };
    }
    case GlobalActions.PREISE_STRECKE_ERMITTELT: {
      const actionPayload: PreiseStreckeErmittelt = action.payload;
      const taasResponsePayload = actionPayload.taasResponsePayload;
      if (
        actionPayload.appId === App.VWG &&
        actionPayload.angebotsId === state.angebotsId &&
        taasResponsePayload?.gisDaten &&
        !state.vertragsoptionen?.beibehalten
      ) {
        return {
          ...sectionState,
          ...actionPayload.taasResponsePayload.gisDaten,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VwgVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VWG && actionPayload.angebotsId === state.angebotsId) {
        return { ...actionPayload.gisDaten };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
